import { render, staticRenderFns } from "./parentEdit.vue?vue&type=template&id=c2a71944&scoped=true&"
import script from "./parentEdit.vue?vue&type=script&lang=js&"
export * from "./parentEdit.vue?vue&type=script&lang=js&"
import style0 from "./parentEdit.vue?vue&type=style&index=0&id=c2a71944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a71944",
  null
  
)

export default component.exports